import type { AvailableIconName } from '@/assets/icons';
import type { auth } from '@/features/auth/types';

export type NotificationPreferenceKey = keyof Pick<
  auth.NotificationPreferences,
  'classReminders' | 'coachNotes' | 'tournamentUpdates' | 'coGuardianActivity'
>;

export type NotificationPreferenceItem = {
  key: NotificationPreferenceKey;
  icon: AvailableIconName;
  title: string;
  subtitle: string;
};
